/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * A valid ISO 639-1 language code supported by the system.
 */
export type Locale = 'it' | 'en' | 'sq' | 'hu' | 'fr' | 'es' | 'ro' | 'pt' | 'zh' | 'ar' | 'el' | 'de' | 'uk' | 'tr' | 'pl' | 'he' | 'lv' | 'bg' | 'ka' | 'sv' | 'nl' | 'be' | 'sk' | 'bs' | 'ca' | 'hy' | 'bn' | 'ja';

export const Locale = {
    It: 'it' as Locale,
    En: 'en' as Locale,
    Sq: 'sq' as Locale,
    Hu: 'hu' as Locale,
    Fr: 'fr' as Locale,
    Es: 'es' as Locale,
    Ro: 'ro' as Locale,
    Pt: 'pt' as Locale,
    Zh: 'zh' as Locale,
    Ar: 'ar' as Locale,
    El: 'el' as Locale,
    De: 'de' as Locale,
    Uk: 'uk' as Locale,
    Tr: 'tr' as Locale,
    Pl: 'pl' as Locale,
    He: 'he' as Locale,
    Lv: 'lv' as Locale,
    Bg: 'bg' as Locale,
    Ka: 'ka' as Locale,
    Sv: 'sv' as Locale,
    Nl: 'nl' as Locale,
    Be: 'be' as Locale,
    Sk: 'sk' as Locale,
    Bs: 'bs' as Locale,
    Ca: 'ca' as Locale,
    Hy: 'hy' as Locale,
    Bn: 'bn' as Locale,
    Ja: 'ja' as Locale
};